import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    flex: '1 1 auto',
    maxHeight: 300,
    margin: `0 0 ${theme.spacing(3)} 0`,
    overflowY: 'hidden',
  },
}));

export default useStyles;
